module.exports = __webpack_public_path__ + "img/bannerImage.6845849f.png";